export const TASKS_LIST_MODALS = {
  delete: 'delete',
  create: 'create',
  edit: 'edit',
  tableFilter: 'tableFilter'
};
